module.exports = __webpack_public_path__ + "static/media/gif_SE_step_1.61b13211.gif";